import { Routes } from '@angular/router';
import { PermissionsList } from '../../shared/common/PermissionList';
import { AuthorizationGuard } from '../../core/auth/guards/authorization.guard';


export const BluePrintRoutes: Routes = [
  {
    path: 'route-sheet',
    loadComponent: () => import('./pages/bluePrint/bluePrint.component').then(m => m.BluePrintPageComponent),
    title: 'Route Sheet | ADROIT',
    data: {
      animation: 'home',
      PermissionPageName: [PermissionsList[PermissionsList.RideBlueprintView]],
    },
    canActivate: [AuthorizationGuard],
  },
];
